import React from "react";
import { Select } from "../../../../../../shared/infrastructure/ui";
import { SelectComponentProps } from "./types";
import { useInfiniteGetDispatcherDivisions } from "../../../services";
import { withSelectOptions } from "./with-select-options";
import {
  DispatcherDivisionT,
  UseGetDispatcherDivisionFilters,
} from "../../../../domain/entities";

const RenderOption = ({ country }: DispatcherDivisionT): React.ReactElement => {
  return (
    <section className="grid grid-flow-col items-center justify-between px-[5px] text-[12px]">
      <span>{country ?? "- -"}</span>
    </section>
  );
};

const DispatcherDivisionSelectComponent = ({
  placeholder,
  name = "",
  selectedValue,
  onChangeValue,
  error = "",
  variant = "standard",
  disabled = false,
  handleSetKeyword,
  isLoading,
  getNextPage,
  noMore,
  data,
  noError,
  labelProp = "country",
  keyword,
  multiselect,
}: SelectComponentProps<DispatcherDivisionT>): React.ReactElement => {
  return (
    <Select<DispatcherDivisionT>
      searchValue={keyword}
      multiselect={multiselect}
      disabled={disabled}
      loading={isLoading}
      placeholder={placeholder}
      options={data}
      name={name}
      asyncFilter={handleSetKeyword}
      labelProp={labelProp}
      value={selectedValue}
      onChange={onChangeValue}
      noMore={noMore}
      getMore={getNextPage}
      renderOptionComponent={RenderOption}
      error={error}
      variant={variant}
      noError={noError}
    />
  );
};

export const DispatcherDivisionSelect = withSelectOptions<
  DispatcherDivisionT,
  UseGetDispatcherDivisionFilters
>(
  DispatcherDivisionSelectComponent,
  useInfiniteGetDispatcherDivisions,
  "dispatcher"
);
